import React, { useState } from "react";
import { Link } from "react-router-dom";

import './nav.scss';
import getConfig from "../app/config";

const Nav = ({ tranparent, appUrl, registerUrl }: any) => {

    const [phoneMenuVisible, setPhoneMenuVisible] = useState(false);

    const burgerClick = () => {
        setPhoneMenuVisible(!phoneMenuVisible);
    };

    const hideMenu = () => {
        setPhoneMenuVisible(false);
    };

    const { beta: isBeta } = getConfig() as any;

    return (
        <nav className={`navbar marketing-navbar ${(tranparent && !phoneMenuVisible) ? "is-transparent" : "white"} is-fixed-top`}>
            <div className="marketing-navbar-brand navbar-brand">
                <a className="navbar-item" href="/">
                    <div className={`nav-logo ${(tranparent && !phoneMenuVisible) ? "invisible" : ""}`}>
                        <img src="/images/logo-black.svg" alt="Filmanize: film production management" />
                        {isBeta && <span className="tag is-purple is-beta">Beta</span>}
                    </div>
                </a>

                <div className={`navbar-burger ${phoneMenuVisible ? "open" : ""}`} data-target="navbarFilmanize" onClick={burgerClick}>
                    <span className="bar1"></span>
                    <span className="bar2"></span>
                    <span className="bar3"></span>
                </div>
            </div>

            <div id="navbarFilmanize" className={`navbar-menu ${phoneMenuVisible ? "is-active" : ""}`}>
                <div className="navbar-start">

                </div>

                <div className="navbar-end">
                    <div className="navbar-item">
                        <a href="/#features" className={`${(tranparent) ? "green-hover-link" : "purple-hover-link"}`} onClick={hideMenu}>Features</a>
                    </div>
                    <div className="navbar-item">
                        <a href="/#pricing" className={`${(tranparent) ? "green-hover-link" : "purple-hover-link"}`} onClick={hideMenu}>Pricing</a>
                    </div>
                    <div className="navbar-item has-dropdown is-hoverable more">
                        <a href="" className={`${(tranparent) ? "green-hover-link" : "purple-hover-link"}`}>More
                            <svg className="more-arrow" xmlns="http://www.w3.org/2000/svg" width="15.262" height="7.977" viewBox="0 0 15.262 7.977">
                                <g id="noun-arrow-1830606" transform="translate(-82.66 -151.192)">
                                    <path id="Path_32922" data-name="Path 32922" d="M111.136,159.168a.867.867,0,0,1-.542-.228l-6.763-6.242h0a.869.869,0,1,1,1.181-1.273l6.172,5.695,6.172-5.7a.868.868,0,1,1,1.181,1.273l-6.763,6.242h0a.867.867,0,0,1-.639.228Z" transform="translate(-20.893 0)" />
                                </g>
                            </svg>
                            {/* <img src="/images/marketing/menu-down-arrow.svg" alt="down arrow" ></img> */}
                        </a>
                        <div className={`navbar-dropdown is-right is-boxed marketing-dropdown marketing-dropdown${(tranparent) ? "-transparent" : "-white"}`}>

                            <Link to="/case-studies" className={`navbar-item `}>
                                Case Studies
                            </Link>

                            <Link to="/blogs" className={`navbar-item `}>
                                Blog
                            </Link>
                            <Link to="/about-us" className={`navbar-item `}>
                                About Us
                            </Link>
                            <Link to="/contact" className={`navbar-item `}>
                                Contact
                            </Link>
                        </div>
                    </div>
                    <div className="navbar-item">
                        <a href={registerUrl} className={`button is-light ${(tranparent) ? "" : "green-border"}`}>{isBeta ? "Try the beta" : "Try for free"}</a>
                    </div>
                    <div className="navbar-item">
                        <a href={`${appUrl}/login`} className="button hollow-button">Login</a>
                    </div>
                </div>
            </div>
        </nav>
    )
}

export default Nav;